import type { SVGProps } from "react";

export function Cake(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 20h16v-7a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v7z" />
      <path d="M8 8V5a2 2 0 1 1 4 0v3" />
      <path d="M12 8V6a2 2 0 1 1 4 0v2" />
    </svg>
  );
}
